export default __webpack_public_path__ + "static/media/hht2_Intonation_03.bc136354.png";